/**
 * Devices Slice - Manages audio device selection and enumeration
 */

import { StateCreator } from 'zustand';
import { DevicesSlice } from './index.types';

export * from './index.types';

export const createDevicesSlice: StateCreator<DevicesSlice> = (set) => ({
  // State
  microphones: [],
  speakers: [],
  ringers: [],
  selectedMicrophone: null,
  selectedSpeaker: null,
  selectedRinger: null,
  permissionState: 'prompt',
  audioPlaying: {
    ringtone: false,
    ringback: false,
    callDisconnected: false,
    lostConnection: false,
    secondIncoming: false,
    remoteAudio: false,
    videoStart: false,
    videoJoin: false,
    videoLeave: false,
    videoEnded: false,
    dtmf0: false,
    dtmf1: false,
    dtmf2: false,
    dtmf3: false,
    dtmf4: false,
    dtmf5: false,
    dtmf6: false,
    dtmf7: false,
    dtmf8: false,
    dtmf9: false,
    dtmfStar: false,
    dtmfPound: false
  },

  // Actions
  setMicrophones: (devices) => set({ microphones: devices }),
  setSpeakers: (devices) => set({ speakers: devices }),
  setRingers: (devices) => set({ ringers: devices }),
  setSelectedMicrophone: (deviceId) => set({ selectedMicrophone: deviceId }),
  setSelectedSpeaker: (deviceId) => set({ selectedSpeaker: deviceId }),
  setSelectedRinger: (deviceId) => set({ selectedRinger: deviceId }),
  setPermissionState: (state) => set({ permissionState: state }),
  setAudioPlaying: (type, isPlaying) =>
    set((state) => ({
      audioPlaying: { ...state.audioPlaying, [type]: isPlaying },
    })),
});
